<style>
  .avgForm {
    padding-bottom: 80px;
    padding-top: 50px;
    padding-left: 20px;
  }
</style>

<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        เพิ่มรายการอัตราค่าบริการเพื่อการกำกับดูแล
        <small></small>
      </h1> 
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> เพิ่มรายการอัตราค่าบริการเพื่อการกำกับดูแล
          </a>
        </li>
        <li class="active">เพิ่มรายการส่งเสริมการขายโทรศัพท์เคลื่อนที่</li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">

              <div class="row">
                <div class="col-sm-12">
                    <el-form
                      size="mini"
                      :label-position="label_position"
                      label-width="100px"
                      :model="form"
                      ref="ruleForm"
                      class="demo-ruleForm avgForm"
                    >
                      <el-form-item label=" ชื่ออัตราการกำกับดูแล" required>
                        <el-input clearable v-model="form.service_name" style="max-width: 550px"></el-input>
                      </el-form-item>
                      <el-form-item label="ค่าบริการเสียงเพื่อการกำกับ (บาท/นาที)">
                        <el-input-number :precision="2" :step="0.01"  v-model="form.voice_service_rate" @keypress.native="isDecimalKey"></el-input-number>
                      </el-form-item>
                      <el-form-item label="ค่าบริการ SMS เพื่อการกำกับ (บาท/ข้อความ)">
                        <el-input-number :precision="2" :step="0.01" v-model="form.sms_service_rate" @keypress.native="isDecimalKey"></el-input-number>
                      </el-form-item>
                      <el-form-item label="ค่าบริการ MMS เพื่อการกำกับ (บาท/ข้อความ)">
                        <el-input-number :precision="2" :step="0.01" v-model="form.mms_service_rate" @keypress.native="isDecimalKey"></el-input-number>
                      </el-form-item>
                      <el-form-item label="ค่าบริการข้อมูล (อินเทอร์เน็ต) เพื่อการกำกับ (บาท/MB)">
                        <el-input-number :precision="2" :step="0.01" v-model="form.internet_service_rate" @keypress.native="isDecimalKey"></el-input-number>
                      </el-form-item>
                      
                      <div class="row">
                        <div class="col-sm-12">
                          <el-form-item label="วันที่เริ่มการกำกับดูแล">
                            <el-date-picker
                              v-model="form.start_date"
                              type="date"
                            ></el-date-picker>
                          </el-form-item>

                          <el-form-item label="วันที่สิ้นสุดการกำกับดูแล">
                            <el-date-picker
                              v-model="form.end_date"
                              type="date"
                            ></el-date-picker>
                          </el-form-item>
                        </div>
                      </div>
                      <button
                        type="button"
                        class="btn btn-primary"
                        style="margin-top: 12px;margin-bottom: 12px;float: left;"
                        @click="add_average(form)"
                      >บันทึก</button>
                    </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
const moment = require("moment");
export default {
  data() {
    return {
      label_position: "top",
      form: {
        service_name: "",
        voice_service_rate: "",
        sms_service_rate: "",
        mms_service_rate: "",
        internet_service_rate: "",
        start_date: null,
        end_date: null,
        admin_id: this.$cookies.get("user_nbtc").admin_id
      }
    }
  },
  methods: {
    ...mapActions({
       add_average: "Manage_average/add_average",
    })
  }
};
</script>
